<app-maintenance-gate>
    <div appCatchEvents appRouterValidator>
        <app-header>
            <div class="root">
                @if (isLoading$ | async) {
                    <app-initial-loader />
                }
                @if ((isLoading$ | async) === false) {
                    <router-outlet />
                }
            </div>
        </app-header>
    </div>
</app-maintenance-gate>
